const FALLBACK_PRODUTO_IMAGEM = 'data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22120%22 height=%22120%22 viewBox=%220 0 120 120%22%3E%3Crect width=%22120%22 height=%22120%22 rx=%2210%22 fill=%22%23eef2f7%22/%3E%3Cpath d=%22M33 44h54v36H33z%22 fill=%22%23d8dee9%22/%3E%3Cpath d=%22M42 54h36v6H42zm0 12h28v6H42z%22 fill=%22%23919aab%22/%3E%3C/svg%3E'

const CAMPOS_IMAGEM = ['url', 'urlArquivo', 'downloadUrl', 'caminho', 'path', 'arquivoId', 'id']

export function valorImagemProduto(produto = {}) {
	const fotos = produto.urlsFotos || produto.fotos || produto.imagens
	if (Array.isArray(fotos)) {
		const foto = fotos.find(item => item !== null && item !== undefined && String(item).trim() !== '')
		if (foto !== undefined) return foto
	}

	return produto.imagemUrl || produto.fotoUrl || produto.imageUrl || produto.urlImagem || produto.imagem || produto.foto || ''
}

export function extrairValorArquivo(valor) {
	if (valor === null || valor === undefined) return ''
	if (typeof valor !== 'object') return valor

	for (const campo of CAMPOS_IMAGEM) {
		if (valor[campo] !== null && valor[campo] !== undefined && String(valor[campo]).trim() !== '') return valor[campo]
	}
	return ''
}

export function resolverUrlArquivo(valor, urlRest = '') {
	const valorArquivo = extrairValorArquivo(valor)
	if (valorArquivo === null || valorArquivo === undefined) return ''

	const caminho = String(valorArquivo).trim().replace(/\\/g, '/')
	if (!caminho) return ''
	if (/^(data:|blob:|https?:\/\/)/i.test(caminho)) return caminho

	try {
		const origemLocal = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
		const baseApi = new URL(urlRest || '/', origemLocal)
		const caminhoLimpo = caminho.replace(/^\.\//, '')

		// Fotos gravadas na pasta de uploads (relativo ou caminho de disco antigo, ex.: C:/xampp/htdocs/uploads_escalador/...)
		// são servidas pela API (rota pública uploads_escalador/); a raiz do servidor não serve essa pasta.
		const indiceUploads = caminhoLimpo.indexOf('uploads_escalador/')
		if (indiceUploads >= 0) return new URL(caminhoLimpo.slice(indiceUploads), baseApi).href

		if (/^\d+$/.test(caminhoLimpo)) return new URL(`arquivos/${caminhoLimpo}/download`, baseApi).href
		if (/^arquivos\/\d+\/download(?:\?.*)?$/i.test(caminhoLimpo)) return new URL(caminhoLimpo, baseApi).href
		if (/^api\//i.test(caminhoLimpo)) return new URL(`/${caminhoLimpo}`, baseApi.origin).href
		if (caminhoLimpo.startsWith('/')) return new URL(caminhoLimpo, baseApi.origin).href

		// O upload atual devolve caminhos de arquivo relativos à origem do backend.
		// Preservar origin mantém protocolo e porta; o código anterior descartava a porta.
		return new URL(`/${caminhoLimpo}`, baseApi.origin).href
	} catch (error) {
		return caminho
	}
}

export function temImagemProduto(produto = {}) {
	return Boolean(extrairValorArquivo(valorImagemProduto(produto)))
}

export function resolverImagemProduto(produto = {}, urlRest = '', fallback = FALLBACK_PRODUTO_IMAGEM) {
	if (!produto || produto.imagemFalhou || produto._imagemFalhou) return fallback
	return resolverUrlArquivo(valorImagemProduto(produto), urlRest) || fallback
}

export { FALLBACK_PRODUTO_IMAGEM }
